module.exports = __webpack_public_path__ + "img/banner4.e102e06a.jpg";